// components/Teams/TeamCard.js
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { getTeamTypeDisplay } from '../../../utils/teamTypeUtils';

const TeamCard = ({ team, isSelected, onSelect, onEdit, onDelete, onExitTeam }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      onDelete(team.team_id);
    }
  };

  const handleExitTeam = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to exit this team?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, exit team!'
    });

    if (result.isConfirmed) {
      onExitTeam(team.team_id);
    }
  };

  const isTeamCreator = team.created_by === team.currentUserId;
  const isMemberOnly = !isTeamCreator && team.is_member;
  
  // Get team type display information
  const typeDisplay = getTeamTypeDisplay(team);

  return (
    <div 
      className={`team-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(team)}
    >
      <div className="team-card-header">
        <div className="team-title-wrapper">
          <h3 className="team-name">{team.team_name}</h3>
          {/* Team Type Badge */}
          
        </div>
        
        <span className="member-count ms-1">
          👥 {team.member_count+1 || 1}
        </span>
        
        {/* Show options button for both creator and members */}
        {(isTeamCreator || isMemberOnly) ? (
          <div className="team-actions">
            <button 
              className="team-options-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowOptions(!showOptions);
              }}
            >
              ⋮
            </button>
            {showOptions && (
              <div className="team-dropdown">
                {/* Show Edit/Delete for creator */}
                {isTeamCreator && (
                  <>
                    <button 
                      className="dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(team);
                        setShowOptions(false);
                      }}
                    >
                      ✏️ Edit
                    </button>
                    <button 
                      className="dropdown-item delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete();
                        setShowOptions(false);
                      }}
                    >
                      🗑️ Delete
                    </button>
                  </>
                )}
                
                {/* Show Exit Team for members only */}
                {isMemberOnly && (
                  <button 
                    className="dropdown-item exit"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleExitTeam();
                      setShowOptions(false);
                    }}
                  >
                    🚪 Exit Team
                  </button>
                )}
              </div>
            )}
          </div>
        ) : null}
      </div>
      <span className={`team-type-badge ${typeDisplay.className}`}>
            {typeDisplay.fullDisplay}
          </span>
      {team.description && (
        <p className="team-description">{team.description}</p>
      )}
      
      <div className="team-meta">
        <span className="created-by">
          👤 By: {team.creator_first_name} {team.creator_last_name}
        </span>
        <span className="created-date">
          📅 {new Date(team.created_at).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
};

export default TeamCard;